import React from "react";
import ContentContainer from "../atoms/ContentContainer";
import FormTitle from "../atoms/FormTitle";
import { useUser } from "../Context/UserContext";
import Logout from "../molecules/Logout";
import { useLocation, withRouter } from "react-router";
import Anchor from "../atoms/Anchor";
import { isProject, PROJECT_INKASSIER } from "../../Services/appTheme";
const renderLink = () => {
    if (isProject(PROJECT_INKASSIER)) {
        return (React.createElement(Anchor, { href: "https://www.inkassier.nl/contact", target: "_blank", title: "Neem contact op met inkassier." }, "contact"));
    }
    return (React.createElement(Anchor, { href: "https://www.invoned.nl/contact", target: "_blank", title: "Neem contact op met Invoned." }, "contact"));
};
const FinishedMessage = () => {
    const { user, form } = useUser();
    const location = useLocation();
    if (location.state && location.state.finalized) {
        return (React.createElement(ContentContainer, null,
            React.createElement(FormTitle, null, "Formulier succesvol verzonden!"),
            React.createElement("p", null,
                form !== "KNT" && (React.createElement(React.Fragment, null,
                    "Uw informatieverzoek voor dossier nr.",
                    " ",
                    React.createElement("strong", null, user === null || user === void 0 ? void 0 : user.doswerk_dossier),
                    " is zojuist verzonden. We sturen u per e-mail een bevestiging van de inzending.")),
                form === "KNT" && (React.createElement(React.Fragment, null,
                    "Het formulier voor",
                    " ",
                    React.createElement("strong", null, user === null || user === void 0 ? void 0 : user.doswerk_dossier),
                    " is zojuist verzonden."))),
            React.createElement("p", null, "Hartelijk dank voor het insturen van dit verzoek. U kunt dit scherm nu sluiten of een nieuw formulier invullen."),
            React.createElement(Logout, { isTextButton: true, hasIconRight: true, buttonText: "Terug naar inloggen" })));
    }
    return (React.createElement(ContentContainer, null,
        React.createElement(FormTitle, null, "Formulier reeds verzonden"),
        React.createElement("p", null,
            "Er is reeds aan dit informatieverzoek voldaan, u hoeft dit niet opnieuw in te vullen. Wilt u gegevens wijzigen, neem dan",
            " ",
            renderLink(),
            " met ons op."),
        React.createElement(Logout, { isTextButton: true, hasIconRight: true, buttonText: "Terug naar inloggen" })));
};
export default withRouter(FinishedMessage);
